import style from "./Modal.module.scss";
import { useUserStore } from "@/core/store/UserDataStore";
import { BannerWarningLine, Button, Popup } from "@aurora/components";
import { GlyphAlert, GlyphInfo } from "@aurora/icons";
import cx from "classnames";
import React, { FC, useMemo } from "react";
import { useNavigate } from "react-router-dom";

interface IProps {
  level: "warning" | "alert";
  licenseNulled?: boolean;
}

const LicenseAlertsModal: FC<IProps> = ({
  level = "warning",
  licenseNulled = false,
}) => {
  const navigate = useNavigate();
  const { isManagerOrWatcher } = useUserStore();

  const title = useMemo(() => {
    if (level === "alert" && !licenseNulled) {
      const title = "Срок действия вашей лицензии истёк.";
      if (isManagerOrWatcher) {
        return (
          title +
          " Обратитесь к администратору платформы для обновления лицензии. " +
          "Это действие необходимо для восстановления доступа к платформе."
        );
      }
      return (
        title +
        " Для восстановления доступа к платформе необходимо продлить лицензию."
      );
    }
    const title =
      "Для того, чтобы начать работу с Carrot, необходимо загрузить файл лицензии.";
    if (isManagerOrWatcher) {
      return title + " Обратитесь к администратору платформы.";
    }
    return title;
  }, [isManagerOrWatcher, level]);

  return (
    <>
      <Popup classNameContent={cx(style.modal, "p-16")} classNameWrapper="p-0">
        <>
          <div className={"title-and-buttons-align"}>
            <h1 className={cx("my-0")}>Обновление лицензии</h1>
            {!isManagerOrWatcher && (
              <div>
                <Button
                  onClick={() => {
                    navigate("/license");
                    return false;
                  }}
                >
                  Обновить
                </Button>
              </div>
            )}
          </div>
          <BannerWarningLine
            addonLeft={level === "alert" ? <GlyphAlert /> : <GlyphInfo />}
            className={style[`Banner--${level}`]}
            title={title}
            variant={level === "alert" ? "primary" : "attention"}
          />
        </>
      </Popup>
    </>
  );
};

export default LicenseAlertsModal;
